module.exports = "./img/76cc2b3946342d56212b427e7fa4fc39.jpg";